<template>
  <div class="container source-of-stress">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="76" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="worryaboutrisks">
    </back-and-skip>
    <div class="row pt-4 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/source_of_stress.svg" alt="source-of-stress">
      </div>
    </div>
    <div class="row pt-4 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('sourceOfStress.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-3">
      <div class="offset-1 col-10 offset-lg-2 col-lg-8 text-center info">
        <label>
          {{ $t('sourceOfStress.info') }}
        </label>
      </div>
    </div>
    <div class="row pt-5 pb-5">
      <!-- <div class="offset-1 col-10 offset-lg-3 col-lg-6">
        <div class="tile-container">
          <div class="tile">1</div>
          <div class="tile">2</div>
          <div class="tile">3</div>
          <div class="tile">4</div>
          <div class="tile">5</div>
          <div class="tile">6</div>
          <div class="tile">7</div>
          <div class="tile">8</div>
          <div class="tile">9</div>
          <div class="tile">10</div>
        </div>
      </div> -->
      <div class="offset-1 col-10 offset-lg-3 col-lg-6">
        <vue-slider v-model="value"
          :min="0"
          :max="10"
          :interval="1"
          :dotSize="18">
        </vue-slider>
      </div>
    </div>
    <div class="row pb-2 row-next">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  data () {
    return {
      value: 0
    }
  },
  components: {
    BackAndSkip,
    VueSlider
  },
  computed: {
    hasCovid () {
      return this.$store.getters.getHasCovid
    }
  },
  methods: {
    next () {
      const answer = {
        key: 'risk_of_getting_virus_been_source_of_stress',
        value: this.value
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      if (this.hasCovid === 'yes') {
        this.$router.push({
          name: 'worryaboutrisks'
        })
      } else {
        const answer = {
          key: 'worry_about_risk_factor_after_vaccine',
          value: null
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'almostdone'
        })
      }
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'preventativehealth')
  }
}
</script>

<style>
.source-of-stress .img-question {
  width: 100%;
  height: 28vh;
}

.source-of-stress .title {
  font-weight: 700;
  font-size: 1.2rem;
}

.source-of-stress .number-space {
  color: red;
}

.source-of-stress .tile-container {
  position: relative;
  width: 100%;
  font-size:0;
  text-align: left;
}

.source-of-stress .tile{
  font-size: 10px;
  width: 10%;
  min-height:22px;
  display: inline-block;
  text-align: right;
}

.source-of-stress .row-next {
  padding-top: 3rem;
}

.source-of-stress .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .source-of-stress .img-question {
    width: 100%;
    height: 16vh;
  }

  .source-of-stress .title {
    font-size: 1rem;
  }

  .source-of-stress .info {
    font-size: .9rem;
  }

  .source-of-stress .row-next {
    padding-top: 2rem;
  }

  .source-of-stress .next {
    min-height: 70px;
  }
}
</style>
